import script from "./ModalBase.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalBase.vue?vue&type=script&setup=true&lang=js"

import "./ModalBase.vue?vue&type=style&index=0&id=2c01f4a9&lang=css"

const __exports__ = script;

export default __exports__